// extracted by mini-css-extract-plugin
export default {"mainPage":"main-page_mainPage__go+rY","title":"main-page_title__0F50O","visuallyHidden":"main-page_visuallyHidden__Qxqm9"};